import { render, staticRenderFns } from "./aztecempire.vue?vue&type=template&id=5497e77e&scoped=true"
import script from "./aztecempire.vue?vue&type=script&lang=js"
export * from "./aztecempire.vue?vue&type=script&lang=js"
import style0 from "./aztecempire.vue?vue&type=style&index=0&id=5497e77e&prod&scoped=true&lang=css"
import style1 from "./aztecempire.vue?vue&type=style&index=1&id=5497e77e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5497e77e",
  null
  
)

export default component.exports